import type { TransportMode } from '../types/import-tracking.types';

export interface TransportModeConfig {
  label: string;
  originLabel: string;
  destinationLabel: string;
  carrierLabel: string;
  documentLabel: string;
  icon: 'Ship' | 'Plane' | 'Truck' | 'TrainFront' | 'Container';
}

export const TRANSPORT_MODE_CONFIG: Record<TransportMode, TransportModeConfig> = {
  SEA: {
    label: 'Marítimo',
    originLabel: 'Puerto Origen',
    destinationLabel: 'Puerto Destino',
    carrierLabel: 'Naviera',
    documentLabel: 'N° BL',
    icon: 'Ship',
  },
  AIR: {
    label: 'Aéreo',
    originLabel: 'Aeropuerto Origen',
    destinationLabel: 'Aeropuerto Destino',
    carrierLabel: 'Aerolínea',
    documentLabel: 'N° AWB',
    icon: 'Plane',
  },
  LAND: {
    label: 'Terrestre',
    originLabel: 'Terminal Origen',
    destinationLabel: 'Terminal Destino',
    carrierLabel: 'Transportista',
    documentLabel: 'N° Carta de Porte',
    icon: 'Truck',
  },
  RAIL: {
    label: 'Ferroviario',
    originLabel: 'Estación Origen',
    destinationLabel: 'Estación Destino',
    carrierLabel: 'Operador Ferroviario',
    documentLabel: 'N° CIM/SMGS',
    icon: 'TrainFront',
  },
  MULTIMODAL: {
    label: 'Multimodal',
    originLabel: 'Origen',
    destinationLabel: 'Destino',
    carrierLabel: 'Operador Logístico',
    documentLabel: 'N° Doc. Transporte',
    icon: 'Container',
  },
};

export const TRANSPORT_MODE_OPTIONS = Object.entries(TRANSPORT_MODE_CONFIG).map(
  ([value, config]) => ({
    value,
    label: config.label,
  })
);

export function getTransportModeConfig(mode?: TransportMode | string): TransportModeConfig {
  return TRANSPORT_MODE_CONFIG[mode as TransportMode] || TRANSPORT_MODE_CONFIG.SEA;
}
